import './Pollution.scss';

import { FC } from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router-dom';

import { PollutionMap } from '../../components';

import { Trip } from '../../types';

const Pollution: FC = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  // @ts-ignore
  const { trips } = state as { trips: Trip[] };

  const points = trips.map(trip => trip.points).reduce((a, b) => [...a, ...b]);

  return (
    <div className="pollution">
      <div className="pollution__container">
        <div className="pollution__container__header">
          <div className="pollution__container__header__button" onClick={() => navigate(-1)}>
            <IoMdArrowBack
              color="#3439d3"
              size={32}
            />
          </div>
          <div className="pollution__container__header__title">Pollution Map</div>
        </div>
        <div className="pollution__container__content">
          <PollutionMap points={points} />
        </div>
      </div>
    </div>
  );
};

export default Pollution;